<div class="header flex items-center">
  <app-player-row
    (click)="
      kingGame().winner.steamid === '-1'
        ? null
        : contextMenuService.open($event, { user: winner() })
    "
    [player]="winner()!"
  ></app-player-row>
  <div class="skins-price">
    Total Value:
    <app-balance-icon />
    {{ totalValue() | number : "1.2-2" }}
  </div>
  <div class="game-id-wrapper">
    <div class="roundid">
      Round:
      {{ kingGame().roundid }}
    </div>
    <div
      class="gameid"
      (click)="
        clipboardService.copy(kingGame().gameid, 'GameID copied to clipboard')
      "
    >
      GameID:
      {{ kingGame().gameid }}
    </div>
  </div>
</div>
<div class="divider horizontal w-full"></div>
<div class="skins">
  <app-skins-list
    [balanceType]="'skins'"
    [skins]="skins()"
    [selectable]="false"
    [config]="{ mobile: { skin_min_width: '130px' } }"
  />
</div>
